<template>
  <!--
    visible 为 false 时整个弹窗(含遮罩)都不渲染。
    之前只在 mounted 里把 store 的 showPost 置成 false，属于"先画出来再撤掉"：
    遮罩已经盖上去了，而且路由页是异步加载的，它 mounted 里又会把 showPost 置回 true，
    时序上抢在后面，结果就是图没了、灰色遮罩还赖着。所以改成从一开始就不渲染。
  -->
  <div class="popup" v-if="visible">
    <div class="masktop" @click="postfn"></div>
    <div class="mask">
      <!-- 图在上、关闭键在下。原来关闭键是 position:absolute right:-50px 挂在图外面的，
           窗口一矮或者浏览器放大，它就整个跑到屏幕外，用户找不到地方关弹窗。 -->
      <div class="show">
        <!-- 新人首充：文字渲染，金额来自 @/utils/firstCharge，不再依赖 userpop.png。
             以前数字印在图里，改一次档位就得换一次图，忘了就会出现"图上写12元、
             实际到账5元"，只能把整个弹窗关掉。现在改档位弹窗会自己跟着变。 -->
        <div v-if="isFirstCharge" class="fc-card" @click="gotoPath">
          <div class="fc-inner">
            <i class="fc-coin c1"></i>
            <i class="fc-coin c2"></i>
            <i class="fc-coin c3"></i>
            <i class="fc-bit b1"></i>
            <i class="fc-bit b2"></i>
            <i class="fc-bit b3"></i>
            <i class="fc-bit b4"></i>
            <span class="fc-pill">新人专享</span>
            <p class="fc-sub">
              首充 <em>{{ fcPrice }}</em> 元 · 赠 <em>{{ fcPercent }}%</em> 额度
            </p>
            <div class="fc-hero-wrap">
              <div class="fc-hero">
                {{ fcGive }}<span class="fc-unit">元</span><br />红包
              </div>
            </div>
            <button class="fc-btn" type="button">立即领取</button>
            <p class="fc-foot">仅限 1 次 · 新用户首次充值礼包</p>
          </div>
        </div>
        <a v-else class="link" @click="gotoPath"
          ><img :src="image" class="show-img"
        /></a>
        <a class="link" @click="postfn"
          ><img class="showimg" :src="close_pic"
        /></a>
      </div>
    </div>
  </div>
  <!-- <div class="popup" v-else>
    <div class="masktop1" @click="postfn"></div>
    <div class="mask1">
      <div class="show1">
        <a class="link"
          ><img class="showimg1" @click="postfn" :src="close_pic"
        /></a>
        <a class="link" @click="gotoPath"
          ><img :src="image" class="show-img1"
        /></a>
      </div>
    </div>
  </div> -->
</template>

<script>
import countdown from "@/components/tempcount/countdown.vue";
import { getNewUser } from "../../utils/storage";
import {
  FIRST_CHARGE_PRICE,
  FIRST_CHARGE_GIVE,
  FIRST_CHARGE_PERCENT,
} from "@/utils/firstCharge";
export default {
  components: {
    countdown,
  },
  computed: {
    fcPrice() {
      return FIRST_CHARGE_PRICE;
    },
    fcGive() {
      return FIRST_CHARGE_GIVE;
    },
    fcPercent() {
      return FIRST_CHARGE_PERCENT;
    },
  },
  data() {
    return {
      //true = 展示新人首充卡片(文字版)；false = 展示 image 那张通知图
      isFirstCharge: false,
      //是否真的要展示这个弹窗。在 created 里定，保证首帧就是最终状态，不会闪一下遮罩。
      visible: false,
      image: "",
      //点击弹窗要跳去的路由。留空表示这张图只是通知，点了不该跳转。
      //跟 image 成对设置，避免"图换了、跳转还留在原地"——上一次就是因为这个把整个
      //gotoPath 注释掉了事，结果新用户点"立即领取"完全没反应。
      targetPath: "",
      close_pic: require("@/assets/images/ad_close.png"),
      isNewUser: false,
      info: {
        currentTime: new Date(),
        startDate: new Date(1635782400000),
        endDate: new Date(1636646400000),
        isFlag: false, //是否显示
      },
    };
  },
  //放在 created 而不是 mounted：mounted 时 DOM 已经插进去了，遮罩会先闪一下再消失。
  created() {
    this.getImagePath();
  },
  methods: {
    //定义方法
    postfn() {
      //向父组件发射xxx事件
      this.visible = false;
      this.$store.commit("updateShowPost", false);
    },
    gotoPath() {
      //只有带跳转目标的弹窗才跳（目前是新用户首充红包 -> 充值页）。
      //"更换网址通知"那张是纯提示，点图不跳转，关闭走右上角的关闭按钮。
      if (!this.targetPath) {
        return;
      }
      this.$store.commit("updateShowPost", false);
      //已经在目标页时再 push 会抛 NavigationDuplicated，弹窗就关不掉了
      if (this.$route.path !== this.targetPath) {
        this.$router.push({ path: this.targetPath });
      }
    },
    getImagePath() {
      this.isNewUser = JSON.parse(getNewUser() != 0);
      //this.image = require("@/assets/images/userpop1.png");
      //this.image = require("@/assets/images/post_618.png");
      //userInfo 为 null 时直接取 blance 会抛异常，整个 mounted 挂掉、image 和
      //targetPath 都不会被赋值，表现就是"弹窗出来了但点了没反应"，所以这里要兜住
      const userInfo = this.$store.state.common.userInfo || {};
      if (userInfo.blance !== null && userInfo.blance > 0) {
        this.isNewUser = false;
        this.image = require("@/assets/images/postnew.png");
        this.targetPath = ""; //更换网址通知，点了不跳
        this.visible = true;
      } else {
        if (this.isNewUser) {
          //新人首充红包，2026-08-22 重新开启，并改成文字卡片(不再用 userpop.png)。
          //金额从 @/utils/firstCharge 取，改档位时弹窗自动跟着变。
          this.isFirstCharge = true;
          this.targetPath = "/pay"; //点卡片/「立即领取」进充值页
          this.visible = true;
        } else {
          this.image = require("@/assets/images/postnew.png");
          this.targetPath = "";
          this.visible = true;
        }
      }
      //this.image = require("@/assets/images/postnew.png");
      // this.isNewUser = false;
      // this.image =
      // "https://tg.sviptuku.com/baseFrame-web/api/search/image/postnew.png";
      // this.isNewUser = false;
      // this.image = "https://tg.aatuku.com/baseFrame-web/api/search/image/postnew1.png";
    },
  },
};
</script>

<style scoped>
@keyframes rotate {
  0% {
    transform: rotateY(0deg);
  }
  100% {
    transform: rotateY(360deg);
  }
}
.popup {
  z-index: 10000;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: all 0.5s;
}

.masktop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000000;
  opacity: 0.5;
}

.mask {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0);
  z-index: 1002;
  /* 纵向排列，图和关闭键作为一个整体居中 */
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 100vw;
  max-height: 100vh;
}

.mask .show {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: transparent;
}

/* 只给上限、宽高都交给浏览器算。
   原来写死 460×460 + object-fit:fill：userpop.png 实际是 387×500 的竖图，
   被硬塞进正方形里，横向拉宽、纵向压扁，"12元红包"几个字明显变形。
   改成只设 max-width/max-height 之后，浏览器按原始比例整体缩放——
   桌面上就是原始尺寸最清晰，窗口变矮或者浏览器放大到 150% 时自动缩小到放得下，
   任何情况下都不会变形，也不会超出屏幕。 */
.show-img {
  display: block;
  width: auto;
  height: auto;
  max-width: 88vw;
  max-height: 78vh;
  cursor: pointer;
}

.mask .show .showimg {
  position: static;
  width: 34px;
  height: 34px;
  margin-top: 16px;
  flex: 0 0 auto;
  cursor: pointer;
}

/* ===== 新人首充弹窗（文字版） =====
   1) 金额/比例全部来自 @/utils/firstCharge，不再印在图片里，改档位不会脱节。
   2) 整张卡片只有 .fc-card 上一个 font-size 是"真实尺寸"，里面所有尺寸都用 em，
      所以卡片是作为一个整体等比缩放的——浏览器放大到 200%、或者窗口很矮时，
      不会出现"字还是大的、卡片却装不下"从而被裁掉的情况。
      font-size 同时受 vw 和 vh 约束(取小者)，因为高度才是弹窗最容易不够用的一维。 */
.fc-card {
  font-size: clamp(6px, min(2.6vw, 2.2vh), 12px);

  position: relative;
  width: 30em;
  padding: 2.5em 2.33em 2.17em;
  border-radius: 1.67em;
  cursor: pointer;
  text-align: center;
  overflow: hidden;
  background:
    radial-gradient(120% 80% at 50% 0%, #3b3a86 0%, rgba(59, 58, 134, 0) 62%),
    linear-gradient(180deg, #2a2968 0%, #1b1b4d 55%, #15153f 100%);
  box-shadow: 0 2em 5em rgba(0, 0, 0, 0.45), inset 0 1px 0 rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 214, 138, 0.22);
}
/* 顶部柔光 */
.fc-card::before {
  content: "";
  position: absolute;
  left: 50%;
  top: -46%;
  width: 118%;
  height: 92%;
  transform: translateX(-50%);
  background: radial-gradient(50% 50% at 50% 50%, rgba(122, 118, 255, 0.5) 0%, rgba(122, 118, 255, 0) 70%);
  pointer-events: none;
}
.fc-inner { position: relative; z-index: 1; }

.fc-pill {
  display: inline-block;
  padding: 0.33em 1.25em;
  border: 1px solid rgba(246, 208, 140, 0.75);
  border-radius: 999px;
  color: #f6d08c;
  font-size: 1.08em;
  letter-spacing: 0.17em;
}
.fc-sub {
  margin: 1.2em 0 0; /* =1.5 卡片em ÷ 本元素 1.25em */
  color: #f3e2bd;
  font-size: 1.25em;
  letter-spacing: 0.07em;
}
.fc-sub em { font-style: normal; color: #ffd88f; font-weight: 700; }

.fc-hero-wrap { position: relative; margin: 1em 0 1.83em; }
/* hero 背后的光晕，让金色大字浮起来 */
.fc-hero-wrap::before {
  content: "";
  position: absolute;
  left: 50%;
  top: 48%;
  width: 86%;
  height: 78%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background: radial-gradient(50% 50% at 50% 50%, rgba(255, 206, 122, 0.22) 0%, rgba(255, 206, 122, 0) 70%);
  pointer-events: none;
}
/* background-clip:text 不支持时退回纯金色，不会变成透明看不见 */
.fc-hero {
  margin: 0; /* 间距在 .fc-hero-wrap 上，别写在这里：本元素 font-size 是 7.17em，em 会被放大 7 倍 */
  font-size: 7.17em;
  font-weight: 900;
  line-height: 1.08;
  letter-spacing: 0.03em;
  color: #ffd88f;
  background: linear-gradient(180deg, #fff4d6 6%, #ffd489 46%, #e0a247 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 0 0.07em 0.21em rgba(0, 0, 0, 0.3);
}
.fc-hero .fc-unit { font-size: 0.52em; margin-left: 0.04em; }

.fc-btn {
  display: block;
  width: 100%;
  padding: 0.83em 0; /* =1.25 卡片em ÷ 本元素 1.5em */
  border: 0;
  border-radius: 999px;
  color: #fff;
  font-size: 1.5em;
  font-weight: 700;
  letter-spacing: 0.17em;
  text-indent: 0.17em; /* 抵掉 letter-spacing 在末字后多出来的一格，否则文字看着偏右 */
  cursor: pointer;
  background: linear-gradient(90deg, #6a5bff 0%, #8f6bff 50%, #6a5bff 100%);
  box-shadow: 0 0.55em 1.45em rgba(106, 91, 255, 0.5);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.fc-btn:hover { transform: translateY(-1px); box-shadow: 0 0.78em 1.78em rgba(106, 91, 255, 0.62); }
.fc-btn:active { transform: translateY(0); }

.fc-foot {
  margin: 1.04em 0 0; /* =1.08 卡片em ÷ 本元素 1.04em */
  color: rgba(232, 226, 255, 0.62);
  font-size: 1.04em;
}

/* 金币与彩带：纯 CSS，不引额外图片。用百分比定位，跟着卡片一起缩放 */
.fc-coin {
  position: absolute;
  border-radius: 50%;
  background: radial-gradient(38% 38% at 34% 30%, #fff2c9 0%, #ffd167 38%, #d99a30 100%);
  box-shadow: 0 0 1.2em rgba(255, 197, 92, 0.55);
  pointer-events: none;
  z-index: 2;
}
.fc-coin.c1 { width: 5.6%; padding-bottom: 5.6%; right: 11%; top: 15%; }
.fc-coin.c2 { width: 7.4%; padding-bottom: 7.4%; right: 6%; top: 47%; }
.fc-coin.c3 { width: 4.6%; padding-bottom: 4.6%; left: 8%; top: 54%; }

.fc-bit {
  position: absolute;
  border-radius: 1px;
  opacity: 0.85;
  pointer-events: none;
  z-index: 2;
}
.fc-bit.b1 { width: 3.2%; height: 1.5%; left: 15%; top: 20%; background: #ff8f6b; transform: rotate(-28deg); }
.fc-bit.b2 { width: 2.4%; height: 1.2%; left: 27%; top: 13%; background: #7ee0d0; transform: rotate(34deg); }
.fc-bit.b3 { width: 2.8%; height: 1.3%; right: 24%; top: 24%; background: #ffd167; transform: rotate(18deg); }
.fc-bit.b4 { width: 2.2%; height: 1.1%; left: 12%; top: 38%; background: #9b8bff; transform: rotate(-14deg); }

.masktop1 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000000;
  opacity: 0.5;
}

.mask1 {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0);
  z-index: 1002;
}

.mask1 .show1 {
  text-align: center;
  margin: auto;
  background-color: transparent;
}
.show-img1 {
  width: 520px;
  height: 730px;
  margin: auto;
  object-fit: fill;
}
.mask1 .show1 .showimg1 {
  position: absolute;
  right: -30px;
  top: -20px;
  width: 50px;
}

.mask .show .showtime {
  position: absolute;
  left: 50%;
  top: 72%;
  transform: translate(-50%, -50%);
  font-size: 18px;
  color: #fff;
}

.link:hover,
.server-table i.el-tooltip:hover {
  cursor: pointer;
  color: #409eff;
}
</style>
